import React from 'react'
import { Select as UiKitSelect } from '@elamajs/ui-kit'

import * as Styled from './Select.styled'

const Select = ({ ...props }) => {
  return <Styled.Select as={UiKitSelect} {...props} />
}

export default Select
